export const getPasswordInputClass = showPassword => (showPassword ? '' : 'password-number-input');
